module.exports = __webpack_public_path__ + "static/media/ppl.bb71742d.jpg";